<script>
import { he } from 'date-fns/locale'

export default {
	name: 'IconSvgPptx',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.3719 4.104C12.9072 4.10355 12.4617 3.92237 12.1331 3.60023C11.8045 3.27809 11.6197 2.8413 11.6193 2.38572V0H3.78734C3.1807 0 2.59892 0.23626 2.16996 0.656792C1.74099 1.07733 1.5 1.64768 1.5 2.2424V15.7602C1.5 16.3549 1.74099 16.9253 2.16996 17.3458C2.59892 17.7663 3.1807 18.0026 3.78734 18.0026H13.1884C13.4888 18.0027 13.7863 17.9448 14.0639 17.8321C14.3415 17.7195 14.5938 17.5543 14.8063 17.3461C15.0188 17.1379 15.1873 16.8906 15.3024 16.6185C15.4174 16.3464 15.4765 16.0547 15.4765 15.7602V4.104H13.3719Z"
				:fill="color" />
			<path
				d="M15.4766 4.104H13.372C12.9072 4.10355 12.4617 3.92237 12.1331 3.60023C11.8045 3.27809 11.6197 2.8413 11.6193 2.38572V0L15.4766 4.104Z"
				fill="#F35858" />
			<path
				d="M17.1348 14.2169H6.50644C5.75252 14.2169 5.14136 14.8161 5.14136 15.5552V18.6617C5.14136 19.4008 5.75252 20 6.50644 20H17.1348C17.8888 20 18.5 19.4008 18.5 18.6617V15.5552C18.5 14.8161 17.8888 14.2169 17.1348 14.2169Z"
				fill="#F35858" />
			<path d="M7.49503 17.7809V18.3867H6.85498V17.7809H7.49503Z" fill="#F3F3F6" />
			<path
				d="M8.43521 17.5077V18.3868H7.81726V15.8811H8.81856C9.1223 15.8811 9.35349 15.955 9.51216 16.1028C9.5927 16.1802 9.65562 16.2735 9.69679 16.3764C9.73795 16.4794 9.75643 16.5898 9.75101 16.7002C9.7537 16.8459 9.71704 16.9896 9.64476 17.1169C9.57045 17.2414 9.4601 17.3414 9.32771 17.4044C9.16861 17.4784 8.99375 17.5142 8.81771 17.5085L8.43521 17.5077ZM9.122 16.7002C9.122 16.478 8.99791 16.3669 8.74971 16.3669H8.43521V17.0194H8.74971C8.99791 17.0216 9.122 16.9152 9.122 16.7002Z"
				fill="#F3F3F6" />
			<path
				d="M10.6732 17.5077V18.3868H10.0544V15.8811H11.0557C11.36 15.8811 11.5915 15.955 11.7502 16.1028C11.8308 16.1802 11.8937 16.2735 11.9348 16.3764C11.976 16.4794 11.9945 16.5898 11.989 16.7002C11.9918 16.846 11.9549 16.9898 11.8819 17.1169C11.8082 17.2415 11.6981 17.3416 11.5657 17.4044C11.4066 17.4784 11.2318 17.5142 11.0557 17.5085L10.6732 17.5077ZM11.3601 16.7002C11.3601 16.478 11.2359 16.3669 10.9877 16.3669H10.6732V17.0194H10.9877C11.2359 17.0216 11.3601 16.9152 11.3601 16.7002Z"
				fill="#F3F3F6" />
			<path d="M14.1294 15.8811V16.3636H13.435V18.3868H12.8136V16.3636H12.126V15.8811H14.1294Z" fill="#F3F3F6" />
			<path
				d="M16.0469 18.3868L15.5088 17.6069L15.0456 18.3868H14.3375L15.1544 17.0969L14.312 15.8811H15.0456L15.57 16.6361L16.0222 15.8811H16.7269L15.9211 17.1427L16.7813 18.3868H16.0469Z"
				fill="#F3F3F6" />
			<path
				d="M7.84868 6.97717H4.13503C4.05064 6.97717 3.96969 6.94437 3.90994 6.88594C3.85018 6.82752 3.81651 6.74825 3.81628 6.66551C3.81628 6.58264 3.84987 6.50316 3.90965 6.44456C3.96942 6.38595 4.0505 6.35303 4.13503 6.35303H7.84528C7.92981 6.35303 8.01091 6.38595 8.07068 6.44456C8.13046 6.50316 8.16403 6.58264 8.16403 6.66551C8.16381 6.74767 8.1306 6.82644 8.07158 6.88476C8.01256 6.94309 7.93248 6.97629 7.84868 6.97717Z"
				fill="#F35858" />
			<path
				d="M7.84868 8.8413H4.13503C4.05064 8.8413 3.96969 8.80848 3.90994 8.75006C3.85018 8.69164 3.81651 8.61238 3.81628 8.52965C3.81628 8.44677 3.84987 8.36727 3.90965 8.30867C3.96942 8.25007 4.0505 8.21716 4.13503 8.21716H7.84528C7.92981 8.21716 8.01091 8.25007 8.07068 8.30867C8.13046 8.36727 8.16403 8.44677 8.16403 8.52965C8.16381 8.61181 8.1306 8.69057 8.07158 8.7489C8.01256 8.80723 7.93248 8.84043 7.84868 8.8413Z"
				fill="#F35858" />
			<path
				d="M7.84868 10.7054H4.13503C4.0505 10.7054 3.96942 10.6724 3.90965 10.6138C3.84987 10.5552 3.81628 10.4757 3.81628 10.3929C3.81696 10.3104 3.85084 10.2316 3.91054 10.1735C3.97024 10.1155 4.05094 10.0829 4.13503 10.0829H7.84528C7.92967 10.0829 8.01062 10.1157 8.07037 10.1741C8.13013 10.2325 8.1638 10.3118 8.16403 10.3945C8.16358 10.4766 8.13028 10.5551 8.07129 10.6133C8.01229 10.6714 7.93233 10.7045 7.84868 10.7054Z"
				fill="#F35858" />
			<path
				d="M7.84868 12.5695H4.13503C4.0505 12.5695 3.96942 12.5365 3.90965 12.4779C3.84987 12.4193 3.81628 12.3398 3.81628 12.257C3.81651 12.1742 3.85018 12.095 3.90994 12.0365C3.96969 11.9781 4.05064 11.9453 4.13503 11.9453H7.84528C7.92967 11.9453 8.01062 11.9781 8.07037 12.0365C8.13013 12.095 8.1638 12.1742 8.16403 12.257C8.16403 12.3393 8.13093 12.4182 8.07189 12.4767C8.01284 12.5353 7.93263 12.5686 7.84868 12.5695Z"
				fill="#F35858" />
			<path
				d="M11.4663 9.83287V7.06299C10.7779 7.09862 10.1298 7.39175 9.65534 7.88196C9.18092 8.37218 8.91639 9.02212 8.91626 9.69787C8.91615 10.0444 8.98567 10.3875 9.12087 10.7076C9.25608 11.0277 9.4543 11.3186 9.70421 11.5636C9.95413 11.8086 10.2508 12.003 10.5774 12.1355C10.9039 12.2681 11.2539 12.3362 11.6074 12.3361C12.2966 12.3362 12.9596 12.0769 13.4596 11.6117C13.9595 11.1465 14.2583 10.511 14.2942 9.83621L11.4663 9.83287Z"
				fill="#F35858" />
			<path
				d="M11.9813 6.85205V9.35195H14.5313C14.4973 8.69974 14.2177 8.08311 13.7466 7.62133C13.2756 7.15954 12.6466 6.88544 11.9813 6.85205Z"
				fill="#F35858" />
		</svg>

	</div>
</template>

<style scoped>

</style>